import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../DATABASE/configFirebase";


export async function uploadPdf(file) {
    if (!file) {throw new Error("Nincs kiválasztott fájl.");}
    if (file.type !== "application/pdf") {throw new Error("Csak PDF fájl tölthető fel.");}
    const fileRef = ref(storage, `documents/${file.name}`);
    const snapshot = await uploadBytes(fileRef, file);
    const url = await getDownloadURL(snapshot.ref);
    return url;
}

export async function getPdfUrl(fileName) {
    const fileRef = ref(storage, `documents/${fileName}`);
    return await getDownloadURL(fileRef);
}